import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { ReactComponent as PersonaIcon } from '../../../../assets/svg/Persona.svg';
import { ReactComponent as EmpresaIcon } from '../../../../assets/svg/Empresa.svg';
import { OnboardingV2State } from '../../../../store/onboardingV2/types.ts';
import styles from './AccountTypeSelector.module.scss';

interface AccountTypeSelectorProps {
  state: OnboardingV2State;
  onAction: (action: string, data?: any) => void;
}

const AccountTypeSelector: React.FC<AccountTypeSelectorProps> = ({ state, onAction }) => {
  return (
    <motion.div
      className={styles.interactiveContainer}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className={styles.accountTypeOptions}>
        <motion.button
          className={`${styles.accountTypeOption} ${state.accountType === 'PERSON' ? styles.active : ''}`}
          onClick={() => onAction('accountType', 'PERSON')}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="button"
        >
          {state.accountType === 'PERSON' && (
            <span className={styles.completionBadge}>
              <Check size={14} />
            </span>
          )}
          <PersonaIcon className={styles.accountTypeIcon} />
          <div className={styles.accountTypeText}>
            <p className={styles.accountTypeTitle}>Profesional</p>
            <p className={styles.accountTypeSubtitle}>Para ofrecer tus servicios o buscar oportunidades.</p>
          </div>
        </motion.button>

        <motion.button
          className={`${styles.accountTypeOption} ${state.accountType === 'COMPANY' ? styles.active : ''}`}
          onClick={() => onAction('accountType', 'COMPANY')}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="button"
        >
          {state.accountType === 'COMPANY' && (
            <span className={styles.completionBadge}>
              <Check size={14} />
            </span>
          )}
          <EmpresaIcon className={styles.accountTypeIcon} />
          <div className={styles.accountTypeText}>
            <p className={styles.accountTypeTitle}>Empresa</p>
            <p className={styles.accountTypeSubtitle}>Para representar a tu negocio.</p>
          </div>
        </motion.button>
      </div>
    </motion.div>
  );
};

export default AccountTypeSelector;
